var build_your_kit_mappings;

$( document ).ready(function(){

    console.log('Build your Kits JS starts here');


    // Check to see if the current page is a build your kit page
    var bodyId = $('body').attr('id');
    var productHandle = $('.shopify-product-form').data('product-handle');
    var supportedProducts = ['build-your-kit-of-three', 'my-first-makeup-kit', 'build-your-kit-of-four', 'build-your-kit-of-five'];
    var isBuildYourKit =  supportedProducts.indexOf(productHandle) > -1 ? true : false;


    if ( isBuildYourKit ) {
        console.log('This is a build your kit product, can proceed.');

        var productMappings = {

            // NEW: lip Gloss
            "lipoilgloss": {
                "Malibu Lip Oil Gloss": "lip-oil-gloss-malibu", 
                "Toffee Lip Oil Gloss": "lip-oil-gloss-toffee",
                "Grapevine Lip Oil Gloss": "lip-oil-gloss-grapevine",
                "Sangria Lip Oil Gloss":"lip-oil-gloss-sangria",
                "Pumpkin Spice Lip Oil Gloss":"lip-oil-gloss-pumpkin-spice",
            },

            "mascaraorsmoked": {
                "Hybrid Mascara": "hybrid-mascara-black",
                "Smoked Kohl Pencil - Black": "smoked-kohl-eyeliner-black",
                "Smoked Kohl Pencil - Brown": "smoked-kohl-eyeliner-brown",
            },


            "lipcremeduo": {
                "Poppy Pink Blush + Illuminate Highlighter": "creme-blush-duo-poppy-pink-illuminate",
            },


            // Lipsticks
            "lipsticks": {
                "apricot-lipstick": "lipstick-apricot",
                "bare-lipstick": "lipstick-bare",
                "berry-lipstick": "lipstick-berry",
                "cocoa-lipstick": "lipstick-cocoa",
                "mauve-lipstick": "lipstick-mauve",
                "nuddy-lipstick": "lipstick-nuddy",
                "plum-lipstick": "lipstick-plum",
                "raisin-lipstick": "lipstick-raisin",
                "rani-lipstick": "lipstick-rani",
                "rhubarb-lipstick": "lipstick-rhubarb",
            },

            "creme-blushes": {
                "creme-blush-dusty-pink": "creme-blush-dusty-pink",
                "creme-blush-deep-rose": "creme-blush-deep-rose",
                "creme-blush-orchid": "creme-blush-orchid",
                "creme-blush-peach": "creme-blush-peach",
                "creme-blush-poppy-pink": "creme-blush-poppy-pink",
                "creme-blush-tan": "creme-blush-tan",
                "creme-bronze": "creme-bronze",
                "creme-highlighter-aura": "creme-highlighter-aura",
                "creme-highlighter-illuminate": "creme-highlighter-illuminate",
            },

            "kohl-pencils": {
                "smoked-kohl-black": "smoked-kohl-eyeliner-black",
                "smoked-kohl-brown": "smoked-kohl-eyeliner-brown",
            },

            "anyone-first": {
                "amethyst-quick-set-liquid-eyeshadow": "amethyst-liquid-eyeshadow",
                "aurora-quick-set-liquid-eyeshadow": "aurora-liquid-eyeshadow",
                "azalea-quick-set-liquid-eyeshadow": "azalea-liquid-eyeshadow",
                "aurus-quick-set-liquid-eyeshadow": "aurus-liquid-eyeshadow",
                "stargazer-quick-set-liquid-eyeshadow": "stargazer-liquid-eyeshadow",
                "aster-quick-set-liquid-eyeshadow": "aster-liquid-eyeshadow",
                "copper-quick-set-liquid-eyeshadow": "copper-liquid-eyeshadow",
                "electra-quick-set-liquid-eyeshadow": "electra-liquid-eyeshadow",
                "luna-quick-set-liquid-eyeshadow": "luna-liquid-eyeshadow",
                "red-metal-quick-set-liquid-eyeshadow": "red-metal-liquid-eyeshadow",
                "hybrid-mascara-black": "hybrid-mascara-black",
                "sangria-lip-oil-gloss": "lip-oil-gloss-sangria",
                "toffee-lip-oil-gloss": "lip-oil-gloss-toffee",
                "grapevine-lip-oil-gloss": "lip-oil-gloss-grapevine",
                "malibu-lip-oil-gloss": "lip-oil-gloss-malibu",
                "pumpkin-spice-lip-oil-gloss": "lip-oil-gloss-pumpkin-spice"
            },

            "anyone-second": {
                "amethyst-quick-set-liquid-eyeshadow": "amethyst-liquid-eyeshadow",
                "aurora-quick-set-liquid-eyeshadow": "aurora-liquid-eyeshadow",
                "azalea-quick-set-liquid-eyeshadow": "azalea-liquid-eyeshadow",
                "aurus-quick-set-liquid-eyeshadow": "aurus-liquid-eyeshadow",
                "stargazer-quick-set-liquid-eyeshadow": "stargazer-liquid-eyeshadow",
                "aster-quick-set-liquid-eyeshadow": "aster-liquid-eyeshadow",
                "copper-quick-set-liquid-eyeshadow": "copper-liquid-eyeshadow",
                "electra-quick-set-liquid-eyeshadow": "electra-liquid-eyeshadow",
                "luna-quick-set-liquid-eyeshadow": "luna-liquid-eyeshadow",
                "red-metal-quick-set-liquid-eyeshadow": "red-metal-liquid-eyeshadow",
                "hybrid-mascara-black": "hybrid-mascara-black",
                "sangria-lip-oil-gloss": "lip-oil-gloss-sangria",
                "toffee-lip-oil-gloss": "lip-oil-gloss-toffee",
                "grapevine-lip-oil-gloss": "lip-oil-gloss-grapevine",
                "malibu-lip-oil-gloss": "lip-oil-gloss-malibu",
                "pumpkin-spice-lip-oil-gloss": "lip-oil-gloss-pumpkin-spice"
            }
        };

        window['build_your_kit_mappings'] = productMappings;

        console.log('XX product kit mapping: XX ', productMappings);


        // Selecting a product in build your kit
        $('body').on('click', '.kit-selection-box[data-kit] .product-item  a', function( e ){
            e.preventDefault();


            $kitParent = $( this ).parents('.kit-selection-box');
            $this = $( this );


            // Remove all active
            $kitParent.find('.product-item  a').removeClass('active');
            $( this ).addClass('active');


            // get current kit
            var currentKit = $kitParent.data( 'kit' );
            console.log( 'Current kit is ' + currentKit  );

            // Get product selection mapping
            var currentValue = $( this ).data('swatch-handle');
            var selectValue = '';
            var mappingObject = build_your_kit_mappings[ currentKit ];

            _.forEach( mappingObject, function(i, key){
                if ( i == currentValue ) {
                    selectValue = key;
                }
            } );


            // Hide the error message
            $kitParent.find('.kit-selection-error').fadeOut();



            // Update the image on left
            var product_images = $this.data('product-images');
            var featured_image = $this.data('featured-image');
            $kitParent.find('.image-box-selected-item').addClass('selected').find('img').attr('src', featured_image);
            $kitParent.find('.image-box-selected-item img').delay(200).fadeIn(200);
            
            if ( product_images ) {
                $kitParent.find('.image-box-selected-item .see-product-images').removeClass('hidden');
                $kitParent.find('.image-box-selected-item .see-product-images').data('product-images', product_images);
                $kitParent.find('.image-box-selected-item').data('product-images', product_images);
            }


            // Trigger the change to select one
            console.log('Changing selected value of ' + currentKit + ' to ' + selectValue );
            $('.line-item-property__field select[data-kit-selection="'+ currentKit +'"]').val( selectValue );
            
            // Selected title name
            var selectedName = $this.data('swatch-shade');
            $kitParent.find('.selected-product-box').removeClass('hidden');
            $kitParent.find('.selected-product-box .selected-product-name').text( selectedName );



        });

        // Getting the images to show up
        $('body').on('click', '.kit-selection-box[data-kit] .see-product-images, .image-box-selected-item', function( e ){
            e.preventDefault();
            e.stopPropagation();
            var $this = $( this );
            var product_images = $this.data('product-images');

            if ( typeof Fancybox == 'function' ) {

                var fancy_images = [];

                product_images.map(function(img){
                    fancy_images.push({
                        src: img,
                        type: 'image'
                    });
                });

                const options = {
                    dragToClose: false,
                    Toolbar: false,
                    closeButton: "top",
                    Image: {
                        zoom: false,
                        fit: 'contain',
                    },

                    on: {
                        initCarousel: (fancybox) => {
                          const slide = fancybox.Carousel.slides[fancybox.Carousel.page];
                    
                          console.log('initCarousel: ', slide);
                          console.log( fancybox );

                          
                            console.log('setting style property ', `url("${slide.thumb}")`);
                            
                          /*
                          fancybox.$container.style.setProperty(
                                "--bg-image",
                                `url("${slide.thumb}")`
                              );
                          */
                          
                        },
                        "Carousel.change": (fancybox, carousel, to, from) => {
                          const slide = carousel.slides[to];
                          console.log('Carousel Change: ', slide);

                          
                            console.log('setting style property ', `url("${slide.thumb}")`);
                          /*  
                          fancybox.$container.style.setProperty(
                                "--bg-image",
                                `url("${slide.thumb}")`
                              );
                          */
                        
                          
                          /*
                          fancybox.$container.style.setProperty(
                            "--bg-image",
                            `url("${slide.$thumb.src}")`
                          );
                          */
                        },
                    },
                }
                const fancybox = Fancybox.show(fancy_images, options);

            }
        });


    }

});